/**
 * Shared status colour helpers for the dashboards (compliance / connectivity).
 *
 * Currently used only by the Assets dashboard tile view — other dashboards that hardcode the
 * same hex values can adopt these incrementally.
 */

/** Status colour palette. */
export const STATUS_COLORS = {
  critical: '#FF3630', // NonCompliant / Offline / has alerts
  warning: '#FFBF00', // PartiallyCompliant / Partial
  ok: '#3FA43F', // Compliant / Online / no alerts
  unknown: '#85868E', // Unknown / other
} as const;

/**
 * Severity rank for a compliance OR connectivity status — higher is worse.
 * 3 = NonCompliant/Offline, 2 = PartiallyCompliant/Partial, 1 = Compliant/Online, 0 = Unknown/other.
 */
export function getStatusSeverity(status: string): number {
  switch (status) {
    case 'NonCompliant':
    case 'Offline':
      return 3;
    case 'PartiallyCompliant':
    case 'Partial':
      return 2;
    case 'Compliant':
    case 'Online':
      return 1;
    default:
      return 0;
  }
}

const SEVERITY_COLOR = [STATUS_COLORS.unknown, STATUS_COLORS.ok, STATUS_COLORS.warning, STATUS_COLORS.critical];

/** Colour for a single compliance/connectivity status. */
export function getStatusColor(status: string): string {
  return SEVERITY_COLOR[getStatusSeverity(status)];
}
